import type { UserListPresentation } from '../../presentations';

type UploadStatusRow = React.ComponentProps<
  typeof UserListPresentation
>['uploadStatusRows'][number];

type SortState = {
  key: 'status' | 'receptNo' | 'scheduledAt' | 'registeredCount' | null;
  direction: 'asc' | 'desc';
};

type ISortUploadStatusRows = (rows: UploadStatusRow[], sortState: SortState) => UploadStatusRow[];

/**
 * アップロード状況テーブルの行をソートして返す純粋関数
 *
 * key が null のときは元の配列をそのまま返す
 */
export const sortUploadStatusRows: ISortUploadStatusRows = (rows, sortState) => {
  const { key, direction } = sortState;
  if (key === null) return rows;

  return [...rows].sort((a, b) => {
    const aVal = a[key];
    const bVal = b[key];
    const compare = aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
    return direction === 'asc' ? compare : -compare;
  });
};
